export default (text) => {
	if (text) {
		let strArr = text.split(' ')
		strArr = strArr.map((str) => {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
		})
		return strArr.join(' ')
	}
}
